import React from 'react'

import { connect } from 'react-redux'
import { Cell } from 'fixed-data-table-2'
import { ParentChildCellConnection } from 'sheets/selectors/column-selectors'
import { Icon as DSIcon } from "quorumdesign"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"
import classNames from "classnames"

export const ParentChildCell =
    ({
        datum,
        evenCell,
        oddCell,
        childDepth,
        isChildAndNotSortingOrSearching,
        className,
        ...props
    }) => (
        <Cell
            className={className + ' parent-child'}
            {...props}
        >
            {isChildAndNotSortingOrSearching && (
                <span
                    className="is-child"
                    style={{ marginLeft: (childDepth * 30) + 'px' }}
                >
                    <DSIcon
                        icon="level-up"
                        iconFamily="fal"
                        rotation={90}
                    />
                </span>
            )}
            <span
                className={classNames({ 'italic-text': isChildAndNotSortingOrSearching })}
            >
                {datum.get('name')}
            </span>
        </Cell>
    )

export default connect((state, props) => ParentChildCellConnection(state, props), {})(ParentChildCell)
